var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StoryTagsList flex flex-wrap gap-2"},_vm._l((_vm.tags),function(tag){return _c('span',{key:tag.id,class:_vm.tagClass},[_vm._v(" "+_vm._s(tag.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }